module.exports = __webpack_public_path__ + "static/pic04.7ce0f8c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic04.jpg
// module id = 487
// module chunks = 114276838955818